module.exports = __webpack_public_path__ + "img/km.ea4e5f33.svg";